var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKodexIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "730px",
    height: "949px",
    viewBox: "0 0 730 949",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(30.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M700,430.594883 C700,390.1258 687.695869,349.656716 663.087608,309.187633 L435.515084,1 L228.461394,1 L549.301346,430.594883 L221,877 L428.05369,877 L663.087608,550.134328 C687.695869,510.910448 700,471.063966 700,430.594883 Z",
    id: "Path",
    fill: "#EF6924",
    transform: "translate(460.500000, 439.000000) scale(-1, 1) translate(-460.500000, -439.000000) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4B76A5",
    x: 0,
    y: 0,
    width: 182,
    height: 877
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKodexIcon);
export default __webpack_public_path__ + "static/media/kodex_icon.1857814b457b2d365b2db02414956b05.svg";
export { ForwardRef as ReactComponent };